module.exports = __webpack_public_path__ + "static/img/page01_person.bb1a603.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page01_person.png
// module id = BwB7
// module chunks = 1